import {store} from "./store"

export function selectSelectedValues() {
    const state = store.getState();
    let selectedChoices = state.questions.quizQuestionData.filter((item => Boolean(item.choices))).map(card => {
        let selected = card.choices.filter(choice => choice.selected === true)
        return selected.map(a => isNaN(a.option) ? 0 : Number(a.option))
    }).flat();
    const selectedBreed = state.questions.quizQuestionData.find((item => item.type === "breed")).value;
    selectedChoices = selectedChoices.filter(elem => elem!==0)
    if (isNaN(selectedBreed) || !Number(selectedBreed)) return [...selectedChoices];
    else return [...selectedChoices, selectedBreed];

}